/**
 * 模型调用的等待提示文案。按钮上的「正在整理…」看不出是在干活还是卡住了,
 * 人等到十几秒就会刷新或重点 —— 而那样会把这一轮打断,还要再花一次钱。
 * 前 5 秒不说话(大多数一问一答走不到这里),之后告诉他等了多久;等得太久再明确说不用重试。
 */
export const WAIT_HINT_AFTER_SECONDS = 5;
export const WAIT_HINT_LONG_SECONDS = 45;

export function waitHint(seconds: number, working = "AI 正在整理"): string {
  if (seconds < WAIT_HINT_AFTER_SECONDS) return "";
  const elapsed = `${working},已等待 ${Math.floor(seconds)} 秒`;
  return seconds < WAIT_HINT_LONG_SECONDS ? `${elapsed}。` : `${elapsed},内容较多时要久一些,请不要刷新或重新提交。`;
}
